var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isSvg)?_c('tspan',{class:{ 'magenta-fill': _vm.layout.isMagenta },attrs:{"xml:space":"preserve"}},[_vm._v(_vm._s(_vm.text))]):_c('span',{class:{ 'magenta-text': _vm.layout.isMagenta },domProps:{"innerHTML":_vm._s(_vm.text)}})}
var staticRenderFns = []

export { render, staticRenderFns }